import {useEffect, useState} from 'react';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {ToastService} from '../../../AppToast';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useTranslation} from '../../../shared/language';
import {RegisterInvoiceService as Service} from '../../../service/invoice/RegisterInvoiceService';
export const useDialogRegisterInvoice = (props) => {
  const {t} = useTranslation();
  const [requiredParams, setRequiredParams] = useState(null);
  const {registerInvoices, registerInvoice, selectionMode} = props;
  const [registerInvoiceOptions, setRegisterInvoiceOptions] = useState([]);
  const [display, setDisplay] = useState(false);
  const [invoiceSerials, setInvoiceSerials] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [perPageOptions, setPerPageOptions ]= useState([50, 100, 200,300]);
  const showRegisterInvoiceDialog = () => {
    const _invoiceSerials = [];
    registerInvoices.forEach(item => {
      _invoiceSerials.push({value: item.symbolCode, label: item.label});
    });
    setInvoiceSerials(_invoiceSerials);
    setDisplay(true);
  }

  useEffect(() => {
    setRequiredParams({});
  },[registerInvoices])
   
  const handleSubmit = () => {
    let InvoiceIdArray;
    if (Array.isArray(selectedItems) && selectedItems.length) {
      InvoiceIdArray = selectedItems.map(({id}) => id);
      copyRegisterInvoice(InvoiceIdArray);
    }  
  }

  const copyRegisterInvoice = (data) => {
    Service.copyRegisterInvoice(data).then(res => {
      setDisplay(false);
      refreshLazyData();
    })
  }

  const {render: renderDataTable, refreshLazyData, selectedItems, clearItems} = useDataTable({
    header: '',
    dataKey: 'id',
    columns: [
      {field: 'invoiceTypeName', header: t('common.invoiceType'), width: 430, matchMode: 'contains'},
      {field: 'symbolCode', header: t('common.symbol'), width: 200, matchMode: 'contains'},
    ],
    heightCalc: 350,
    requiredParams,
    getList: (params) => {
      return Service.getUsingOfYearList(params);
    },
    selectionMode,
    perPageOptions
  });

  const renderRegisterInvoice = () => {
    return (
      <Dialog header={t('common.financialYearTemplateTitle')} visible={display} style={{width: '60rem'}} position="top" onHide={() => setDisplay(false)}>
        <div className="grid">
          <div className="col-12">
            <div>
            {t('common.financialYearTemplateNotice')}
            </div>
            {renderDataTable()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label={t('common.copyInvoiceTemplate')} icon="pi pi-upload" onClick={handleSubmit} loading={submitting} className="p-button-sm mr-2"/>
          <Button label={t('common.close')} icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-sm p-button-raised p-button-text p-button-plain"/>
        </div>
      </Dialog>
    );
  }

  return {renderRegisterInvoice, showRegisterInvoiceDialog};

}
